import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RHFTextField } from 'src/components/hook-form';
import useGetSelectOption from 'src/hooks/useGetSelectOption';
import { FormInnerContainer, FormItem, FormLabel, FormRow } from 'src/layouts/form/FormLayout';
import { ICategory } from 'src/models';
import { FormType, TFormType } from 'src/static/constants';

interface ICategoryFormItemProps {
  formType: TFormType;
  selectedData?: ICategory;
}

// 카테고리 정보 인터페이스
interface ICategoryInfo {
  langCd: string;
  categoryNm: string;
  mainTitle: string;
  mainDesc: string;
  subTitle: string;
  subDesc: string;
  pipeline: string;
  pipelineList: string;
  categoryInfoSid: number;
}

export const InfoByLang = ({ formType, selectedData }: ICategoryFormItemProps) => {
  const { t } = useTranslation();
  const { getLang } = useGetSelectOption();
  const langList = getLang();
  const { watch } = useFormContext();
  return (
    <>
      {langList.map((lang) => {
        const index = watch('categoryInfoList')?.findIndex((info: ICategoryInfo) => {
          if (formType === FormType.UPDATE) {
            const categoryInfo = selectedData?.categoryInfoList?.find(
              (item: any) => item.langCd === lang.value,
            ) as ICategoryInfo;
            return info.categoryInfoSid === categoryInfo?.categoryInfoSid;
          } else {
            return info.langCd === lang.value;
          }
        });

        return (
          <FormInnerContainer key={lang.value} sx={{ gap: 1 }}>
            <FormLabel>{lang.label}</FormLabel>
            <FormRow sx={{ gridTemplateColumns: '1fr' }}>
              <FormItem>
                <RHFTextField
                  label={t('category.form.categoryNm')}
                  name={`categoryInfoList.${index}.categoryNm`}
                />
                <input type="hidden" name={`categoryInfoList.${index}.langCd`} value={lang.value} />
              </FormItem>
            </FormRow>
            <FormRow sx={{ gridTemplateColumns: '1fr' }}>
              <FormItem>
                <RHFTextField
                  label={t('category.form.mainTitle')}
                  name={`categoryInfoList.${index}.mainTitle`}
                />
              </FormItem>
            </FormRow>
            <FormRow sx={{ gridTemplateColumns: '1fr' }}>
              <FormItem>
                <RHFTextField
                  label={t('category.form.mainDesc')}
                  name={`categoryInfoList.${index}.mainDesc`}
                  multiline
                  rows={2}
                />
              </FormItem>
            </FormRow>
            <FormRow sx={{ gridTemplateColumns: '1fr' }}>
              <FormItem>
                <RHFTextField
                  label={t('category.form.subTitle')}
                  name={`categoryInfoList.${index}.subTitle`}
                  multiline
                  rows={2}
                />
              </FormItem>
            </FormRow>
            <FormRow sx={{ gridTemplateColumns: '1fr' }}>
              <FormItem>
                <RHFTextField
                  label={t('category.form.subDesc')}
                  name={`categoryInfoList.${index}.subDesc`}
                  multiline
                  rows={2}
                />
              </FormItem>
            </FormRow>
            <FormRow sx={{ gridTemplateColumns: '1fr' }}>
              <FormItem>
                <RHFTextField
                  label={t('category.form.pipeline')}
                  name={`categoryInfoList.${index}.pipeline`}
                />
              </FormItem>
            </FormRow>
            <FormRow sx={{ gridTemplateColumns: '1fr' }}>
              <FormItem>
                <RHFTextField
                  name={`categoryInfoList.${index}.pipelineList`}
                  multiline
                  rows={7}
                  placeholder={`${t('category.form.pipelineList')}`}
                />
              </FormItem>
            </FormRow>
          </FormInnerContainer>
        );
      })}
    </>
  );
};
